/* eslint-disable */
import { createTheme } from "@material-ui/core/styles";

const defaultTheme = createTheme({
  palette: {
    type: "light",

    primary: {
      main: "#1C3D35", // Forest Core
      contrastText: "#FFFFFF",
    },

    secondary: {
      main: "#6EBB78", // Active Green
      contrastText: "#030B09",
    },

    success: {
      main: "#007459", // Emerald Lens
    },

    info: {
      main: "#6BC3C8", // Fresh Aqua
    },

    error: {
      main: "#D32F2F",
    },

    background: {
      default: "#FFFFFF",
      paper: "#FFFFFF",
    },

    text: {
      primary: "#030B09",   // Charcoal
      secondary: "#5F6F6A", // Urban Slate
      disabled: "#9EA7A3",
    },
  },

  typography: {
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
    ].join(","),

    h1: { fontWeight: 700 },
    h2: { fontWeight: 600 },
    h3: { fontWeight: 600 },

    button: {
      textTransform: "none",
      fontWeight: 600,
    },
  },

  overrides: {
    /* ================= BUTTON ================= */
    MuiButton: {
      root: {
        borderRadius: 8,
      },
    },

    /* ================= PAPER ================= */
    MuiPaper: {
      rounded: {
        borderRadius: 12,
      },
    },

    /* ================= INPUT BASE ================= */
    MuiInputBase: {
      root: {
        color: "#030B09",
      },
      input: {
        "&:-webkit-autofill": {
          WebkitBoxShadow: "0 0 0 100px #FFFFFF inset",
          WebkitTextFillColor: "#030B09",
        },
        "&.Mui-disabled": {
          color: "#9EA7A3",
          WebkitTextFillColor: "#9EA7A3",
        },
      },
    },

    /* ================= LABEL ================= */
    MuiInputLabel: {
      root: {
        color: "#5F6F6A",
        "&$focused": {
          color: "#1C3D35",
        },
        "&.Mui-error": {
          color: "#D32F2F",
        },
      },
    },

    /* ================= OUTLINED INPUT ================= */
    MuiOutlinedInput: {
      root: {
        "& .MuiOutlinedInput-notchedOutline": {
          borderColor: "#DADFD9",
        },

        "&:hover .MuiOutlinedInput-notchedOutline": {
          borderColor: "#6EBB78",
        },

        "&$focused .MuiOutlinedInput-notchedOutline": {
          borderColor: "#1C3D35",
          borderWidth: 2,
          boxShadow: "0 0 0 2px rgba(28, 61, 53, 0.15)",
        },

        "&.Mui-error .MuiOutlinedInput-notchedOutline": {
          borderColor: "#D32F2F",
        },

        "&.Mui-disabled .MuiOutlinedInput-notchedOutline": {
          borderColor: "#DADFD9",
          backgroundColor: "#F6F8F7",
        },
      },
    },

    /* ================= STANDARD INPUT ================= */
    MuiInput: {
      underline: {
        "&:before": {
          borderBottomColor: "#DADFD9",
        },
        "&:hover:not(.Mui-disabled):before": {
          borderBottomColor: "#6EBB78",
        },
        "&:after": {
          borderBottomColor: "#1C3D35",
        },
      },
    },

    /* ================= FILLED INPUT ================= */
    MuiFilledInput: {
      underline: {
        "&:before": {
          borderBottomColor: "#DADFD9",
        },
        "&:hover:not(.Mui-disabled):before": {
          borderBottomColor: "#6EBB78",
        },
        "&:after": {
          borderBottomColor: "#1C3D35",
        },
      },
    },

    /* ================= HELPER TEXT ================= */
    MuiFormHelperText: {
      root: {
        color: "#5F6F6A",
        "&.Mui-error": {
          color: "#D32F2F",
        },
      },
    },

    /* ================= CHECKBOX ================= */
    MuiCheckbox: {
      root: {
        color: "#5F6F6A",
        "&.Mui-checked": {
          color: "#1C3D35",
        },
      },
    },

    /* ================= RADIO ================= */
    MuiRadio: {
      root: {
        color: "#5F6F6A",
        "&.Mui-checked": {
          color: "#1C3D35",
        },
      },
    },

    /* ================= SWITCH ================= */
    MuiSwitch: {
      switchBase: {
        "&.Mui-checked": {
          color: "#1C3D35",
        },
        "&.Mui-checked + .MuiSwitch-track": {
          backgroundColor: "#6EBB78",
        },
      },
    },
  },
});

export default defaultTheme;
